import React, { useEffect, useState } from "react";
import ViewMoreBtn from "../../components/ViewMoreBtn";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { arrowRight } from "../../../../assets/svg/Svg";
import { NotePencil, Trash } from "@phosphor-icons/react";
import { Col, Row, Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as userSlice from "../../../../redux/slices/userSlice";
import moment from "moment";
import DeleteModal from "../../components/DeleteModal";
import UserDetailsModal from "./UserDetailsModal"; 
import UpdateUserModal from "./UpdateUserModal"; 

const UserList = () => {
  const [data, setData] = useState([]);
  const [deletableId, setDeletableId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [updateModal,setUpdateModal]=useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, userList } = useSelector(state => state.userSlice);

  // Fetch user list on component mount
  useEffect(() => {
    dispatch(userSlice.getUserList());
  }, [dispatch]);

  const handleCloseUpdateForm = () => {
    setUpdateModal(false);
  };

  const handleUpdateUser=async(data)=>{
    console.log(data,"data")
   await dispatch(userSlice.updateUser(selectedUser?.id,data,handleCloseUpdateForm));
   dispatch(userSlice.getUserList());
  }

  // Update data when userList changes
  useEffect(() => {
    if (userList && userList.length > 0) {
      setData(userList);
    } else {
      setData([]);
    }
  }, [userList]);

  const columns = [
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "First Name",
      selector: (row) => row?.first_name,
      sortable: true,
    },
    {
      name: "Mobile No",
      selector: (row) => row?.mobile_no,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => moment(new Date(row?.created_at)).format("DD-MM-YYYY h:mm a"),
      sortable: true,
    },
    // {
    //   name: "Updated At",
    //   selector: (row) => moment(new Date(row?.updated_at)).format("DD-MM-YYYY h:mm a"),
    //   sortable: true,
    // },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex table_action">
          <div className="edit" onClick={() => {handleUpdateForm(row); }}>
            <NotePencil size={18} />
          </div>
          <div className="view_more" onClick={() => handleViewUser(row)}>
            <ViewMoreBtn />
          </div>
        </div>
      ),
    }
  ];

  const handleViewUser = (user) => {
    setSelectedUser(user);
    setViewModal(true);
  };

  const handleUpdateForm = (user) => {
    setSelectedUser(user);
    setUpdateModal(true);
  };

  const handleDeleteUser = () => {
    // Implement delete logic here
  };

  const filteredData = data?.filter(
    (item) =>
      item?.first_name?.toLowerCase().includes(searchText.toLowerCase()) ||
      item?.id?.toString() === searchText
  );

  const handleSearch = (value) => {
    setSearchText(value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const paginationOptions = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "All",
  };

  const paginationPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * paginationPerPage,
    currentPage * paginationPerPage
  );

  const customPagination = () => {
    const page = Math.ceil(filteredData.length / paginationPerPage);
    const pageButtons = [];
    const startPage = Math.max(currentPage - 1, 1);
    const endPage = Math.min(currentPage + 1, page);

    pageButtons.push(
      <button
        key={1}
        className={`btn-pagination ${currentPage === 1 ? "active" : ""}`}
        onClick={() => setCurrentPage(1)}
      >
        1
      </button>
    );

    if (startPage > 2) {
      pageButtons.push(<span key="ellipsis-start" className="pagination-ellipsis">&hellip;</span>);
    }

    for (let i = startPage; i <= endPage; i++) {
      if (i !== 1 && i !== page) {
        pageButtons.push(
          <button
            key={i}
            className={`btn-pagination ${currentPage === i ? "active" : ""}`}
            onClick={() => setCurrentPage(i)}
          >
            {i}
          </button>
        );
      }
    }

    if (endPage < page - 1) {
      pageButtons.push(<span key="ellipsis-end" className="pagination-ellipsis">&hellip;</span>);
    }

    if (page !== 1) {
      pageButtons.push(
        <button
          key={page}
          className={`btn-pagination ${currentPage === page ? "active" : ""}`}
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </button>
      );
    }

    return (
      <div className="pagination-container mt-5">
        <button
          className="btn-pagination btn-pagi_prev"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {arrowRight}
        </button>
        <span>{pageButtons}</span>
        <button
          className="btn-pagination btn-pagi_next"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === page}
        >
          {arrowRight}
        </button>
      </div>
    );
  };

  return (
    <>
      {loading ? (
        <div className="w-100 d-flex">
          <div className="spinner-border text-primary mx-auto" role="status"></div>
        </div>
      ) : (
        <>
          <div>
            <div className="page-header">
              <h3 className="page-title">Customers</h3>
            </div>
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <DataTable
                      title={<h6 className="card-title">Customer List</h6>}
                      columns={columns}
                      data={paginatedData}
                      pagination
                      paginationServer
                      paginationTotalRows={filteredData.length}
                      onChangePage={(page) => setCurrentPage(page)}
                      paginationComponentOptions={paginationOptions}
                      paginationComponent={customPagination}
                      highlightOnHover
                      pointerOnHover
                      subHeader
                      subHeaderAlign="left"
                      subHeaderComponent={
                        <Row className="mb-3">
                          <Col md={12}>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search by first name"
                              value={searchText}
                              onChange={(e) => handleSearch(e.target.value)}
                            />
                          </Col>
                        </Row>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* View User Modal */}
          <UserDetailsModal
            viewModal={viewModal}
            setViewModal={setViewModal}
            selectedUser={selectedUser}
          /> 

          <UpdateUserModal
          viewUpdateModal={updateModal}
          setViewUpdateModal={setUpdateModal}
          selectedUser={selectedUser}
          handleUpdateUser={handleUpdateUser}
        />
        </>
      )}
    </>
  );
};

export default UserList;
